// REACT
import React, { Component } from "react";
import "./RemoteSensing.scss";
import NDVInterpretation from "./NDVInterpretation";

class NDVIpanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      legendArrowMargin: 5,
      indexValue: this.props.indexValue,
    };
  }

  componentDidMount() {
    this.setState({
      legendArrowMargin: 5,
      indexValue: "",
    });
  }

  componentDidUpdate(prevProps) {

    if (prevProps.indexValue !== this.props.indexValue) {
      this.setState({
        indexValue: this.props.indexValue,
      });

      const ndvi = parseFloat(this.props.indexValue);

      let newMargin = "";
      const step = 14;
      const start = -5;

      const borderValues = [
        -1.1, -0.2, 0.0, 0.02, 0.05, 0.07, 0.1, 0.12, 0.15, 0.17, 0.2, 0.25,
        0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 1.0,
      ];
      //   console.log("bool", ndvi === borderValues[2]);
      //   console.log("BORDER", borderValues[2]);

      if (ndvi <= borderValues[0]) {
        newMargin = -25;
      } else if ((ndvi > borderValues[0]) & (ndvi <= borderValues[1])) {
        newMargin = -18;
      } else if ((ndvi > borderValues[1]) & (ndvi < borderValues[2])) {
        newMargin = -9;
      } else if (ndvi === borderValues[2]) {
        newMargin = -3;
      } else if ((ndvi > borderValues[2]) & (ndvi <= borderValues[3])) {
        newMargin = start + step;
      } else if ((ndvi > borderValues[3]) & (ndvi <= borderValues[4])) {
        newMargin = start + step * 2;
      } else if ((ndvi > borderValues[4]) & (ndvi <= borderValues[5])) {
        newMargin = start + step * 3;
      } else if ((ndvi > borderValues[5]) & (ndvi <= borderValues[6])) {
        newMargin = start + step * 4;
      } else if ((ndvi > borderValues[6]) & (ndvi <= borderValues[7])) {
        newMargin = start + step * 5;
      } else if ((ndvi > borderValues[7]) & (ndvi <= borderValues[8])) {
        newMargin = start + step * 6;
      } else if ((ndvi > borderValues[8]) & (ndvi <= borderValues[9])) {
        newMargin = start + step * 7;
      } else if ((ndvi > borderValues[9]) & (ndvi <= borderValues[10])) {
        newMargin = start + step * 8;
      } else if ((ndvi > borderValues[10]) & (ndvi <= borderValues[11])) {
        newMargin = start + step * 9;
      } else if ((ndvi > borderValues[11]) & (ndvi <= borderValues[12])) {
        newMargin = start + step * 10;
      } else if ((ndvi > borderValues[12]) & (ndvi <= borderValues[13])) { //13 - 0.35
        newMargin = start + step * 11;
      } else if ((ndvi > borderValues[13]) & (ndvi <= borderValues[14])) {
        newMargin = start + step * 12 - 1;
      } else if ((ndvi > borderValues[14]) & (ndvi <= borderValues[15])) {
        newMargin = start + step * 13 - 1;
      } else if ((ndvi > borderValues[15]) & (ndvi <= borderValues[16])) {
        newMargin = start + step * 14 - 3;
      } else if ((ndvi > borderValues[16]) & (ndvi <= borderValues[17])) {
        newMargin = start + step * 15 - 2;
      } else if ((ndvi > borderValues[17]) & (ndvi <= borderValues[18])) {
        newMargin = start + step * 16 - 2;
      } else if ((ndvi > borderValues[18]) & (ndvi <= borderValues[19])) {
        newMargin = start + step * 17 - 3;
      } else if ((ndvi > borderValues[19]) & (ndvi <= borderValues[20])) {
        newMargin = start + step * 18 - 4;
      } else if ((ndvi > borderValues[20]) & (ndvi <= borderValues[21])) {
        newMargin = start + step * 19 - 5;
        // newMargin = 241
      } else {
        newMargin = 3;
        this.setState({ indexValue: "" });
      }
      this.setState({ legendArrowMargin: newMargin });
    }
  }

  onToggleFilter = () => {
    const newIndex = this.state.toggleActiveIndex === 1 ? 0 : 1;
    this.setState({ toggleActiveIndex: newIndex });
  };

  render() {
    return (
      <div id="indexLegend">
        <div className="indexLegendTitle">Hodnota indexu:</div>
        <span
          id="outputIndex"
          style={{
            position: "relative",
            width: "294px",
            top: "-10px",
            left: this.state.legendArrowMargin + 22,
            fontWeight: "600",
          }}
        >
          {this.state.indexValue}
        </span>
        <img
          src={images["legend_arrow.png"]}
          alt="loading"
          style={{
            position: "relative",
            top: "8px",
            marginLeft: this.state.legendArrowMargin,
            height: "14px",
          }}
        />
        <img
          src={images["legend_ndvi.png"]}
          alt="loading"
          style={{
            position: "relative",
            top: "3px",
            height: "25px",
            padding: "0 12px",
          }}
        />
        <NDVInterpretation ndvi={this.state.indexValue} />
      </div>
    );
  }
}

export default NDVIpanel;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("../../../sidebar/images", false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}